"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FabricSchema = exports.VARIANT_FIELDS = void 0;
const yup = __importStar(require("yup"));
const fabricAttributes_1 = require("../attributes/fabricAttributes");
const utils_1 = require("../utils");
const shared = __importStar(require("./sharedSchemas"));
const types_1 = require("../types");
const utils_2 = require("./utils");
const __1 = require("..");
exports.VARIANT_FIELDS = new Set([
    'lengthM',
    'widthCM',
    'imperfections',
    'price',
    'quantity'
]);
const variantFieldsList = [...exports.VARIANT_FIELDS];
/**
 * Wraps a field schema to create a variant field schema.
 * This schema ensures that the length of this varianted field is equal to the longest varianted field.
 * If the field is not a varianted field, returns true.
 * @param innerSchema the regular field schema to wrap
 * @returns wrapped field schema
 */
const variantableFieldSchema = (innerSchema) => {
    return yup
        .array(innerSchema)
        .required()
        .test('Test varianted length', (value, context) => {
        if (!value)
            return context.createError({});
        const isVariant = utils_1.isFieldVarianted(context.path, context.parent.variantedFields);
        if (isVariant) {
            const numberOfVariants = utils_1.getNumVariants(context.parent);
            if (value.length === numberOfVariants)
                return true;
            return context.createError({
                message: `${context.path} has ${value.length} variants. Should have ${numberOfVariants}`
            });
        }
        if (value.length > 1)
            return context.createError({
                message: `${context.path} is not a variant field, but has ${value.length} variants set`
            });
        return true;
    });
};
const contentSchema = yup
    .object({
    contentType: yup
        .mixed()
        .oneOf(Object.values(fabricAttributes_1.ContentType))
        .required(),
    knownContent: yup.array().when('contentType', {
        is: (contentType) => contentType === fabricAttributes_1.ContentType.Known,
        then: yup
            .array(yup.object({
            content: shared.contentSchema.required(),
            amount: yup
                .number()
                .transform(utils_2.NaNtoUndefined)
                .integer()
                .positive()
                .required()
        }))
            .test('sum 100', 'Known content should equal 100', (v) => {
            if (!v)
                return true;
            return v.reduce((acc, curr) => { var _a; return acc + ((_a = curr.amount) !== null && _a !== void 0 ? _a : 0); }, 0) === 100;
        })
    }),
    estimatedSpecificContent: yup.object().when('contentType', {
        is: (contentType) => contentType === fabricAttributes_1.ContentType.EstimatedSpecific,
        then: yup.object({
            primary: shared.contentSchema.required(),
            secondary: shared.contentSchema
        })
    }),
    estimatedGeneralContent: yup.string().when('contentType', {
        is: (contentType) => contentType === fabricAttributes_1.ContentType.EstimatedGeneral,
        then: shared.contentSchema.required()
    })
})
    .required();
const lengthMSchema = shared.widthLengthBaseSchema
    .required()
    .test('Test length depending on bundleOrRoll', (value, context) => {
    var _a, _b;
    if (!value)
        return context.createError({});
    const errorMsg = context.createError({
        message: ((_a = context.options.context) === null || _a === void 0 ? void 0 : _a.product.bundleOrRoll) === fabricAttributes_1.BundleOrRoll.Bundle
            ? 'Max length of a bundle is 9.99.'
            : 'Max length of a roll is 999.'
    });
    if (((_b = context.options.context) === null || _b === void 0 ? void 0 : _b.product.bundleOrRoll) === fabricAttributes_1.BundleOrRoll.Bundle)
        return value < 9.99 ? true : errorMsg;
    else
        return value < 999 ? true : errorMsg;
});
const feelSchema = yup
    .array(shared.sentenceSetSchema.required('${path} only has spaces'))
    .min(1)
    .max(3)
    .required();
const variantedFieldsSchema = yup
    .array(yup.mixed().oneOf(variantFieldsList).required())
    .optional();
/**
 * When validating a Fabric object, a context obj must be passed to
 * properly validate certain fields (ie. lengthM).
 */
exports.FabricSchema = yup
    .object({
    productType: shared.productTypeSchema(types_1.ProductTypes.Fabric),
    colour: shared.colourSchema,
    colourTone: shared.colourToneSchema,
    uses: shared.usesSchema,
    usesOccasion: yup.array().min(1).required(),
    usesConstruction: yup.array().min(1).required(),
    usesSeason: yup.array().min(1).required(),
    garmentType: yup.array().min(1).optional(),
    garmentGroup: yup.array().min(1).optional(),
    occasionType: yup.array().min(1).optional(),
    occasionGroup: yup.array().min(1).optional(),
    constructionUseType: yup.array().min(1).optional(),
    constructionUseGroup: yup.array().min(1).optional(),
    content: contentSchema,
    bundleOrRoll: utils_2.reqSelectOneSchema(Object.values(fabricAttributes_1.BundleOrRoll)),
    lengthM: variantableFieldSchema(lengthMSchema).min(1),
    drape: utils_2.reqSelectOneSchema(Object.values(fabricAttributes_1.Drape)),
    feel: feelSchema,
    pattern: shared.patternSchema,
    border: yup.string().optional(),
    opacity: utils_2.reqSelectOneSchema(Object.values(fabricAttributes_1.Opacity)),
    stretch: shared.stretchSchema,
    // stretchPercentage: yup.number().integer().min(10).max(100),
    widthStretch: yup.number().integer().min(0).max(100).default(0),
    //create a .test() checking to see that if fabric is roll and there is no width and length stretch, throw an arrow
    // Another way could be setting the stretches to be required and then in form utils setting them to 0 under "optional" condidtions (bundle)
    lengthStretch: yup.number().integer().min(0).max(100).default(0),
    knitOrWoven: utils_2.reqSelectOneSchema(Object.values(fabricAttributes_1.KnitOrWoven)),
    knitWeaveType: shared.titleSetLargeSchema,
    quality: shared.qualitySchema.max(30),
    weight: utils_2.reqSelectOneSchema(Object.values(fabricAttributes_1.Weight)),
    bulky: yup.boolean().default(false),
    name: shared.titleSetLargeSchema.required(),
    widthCM: variantableFieldSchema(shared.widthCMSchema).min(1),
    imperfections: variantableFieldSchema(shared.imperfectionsSchema),
    price: variantableFieldSchema(shared.priceSchema).min(1),
    quantity: variantableFieldSchema(shared.quantitySchema.required()).min(1),
    variantedFields: variantedFieldsSchema,
    unboxingDate: yup.date(),
    mediaTag: utils_2.optSelectOneSchema(Object.values(fabricAttributes_1.MediaTag))
})
    .test('Test width/length stretch exists', (value, context) => {
    var _a, _b, _c;
    const errorMsg = context.createError({
        path: 'stretch',
        message: 'width or length stretch must be entered for rolls'
    });
    const isBundleOrRoll = (_a = context.options.context) === null || _a === void 0 ? void 0 : _a.product.bundleOrRoll;
    const widthStretch = (_b = context.options.context) === null || _b === void 0 ? void 0 : _b.product.widthStretch;
    const lengthStretch = (_c = context.options.context) === null || _c === void 0 ? void 0 : _c.product.lengthStretch;
    if (value &&
        isBundleOrRoll === __1.FabricAttributes.BundleOrRoll.Roll &&
        (!widthStretch || widthStretch < 10) &&
        (!lengthStretch || lengthStretch < 10)) {
        return errorMsg;
    }
    else {
        return true;
    }
})
    .test('Test 4-way has length and width stretch', (value, context) => {
    var _a, _b, _c;
    const errorMsg = context.createError({
        path: 'widthStretch',
        message: 'Both width and length stretch must be entered with 4-way stretch'
    });
    const is4Way = (_a = context.options.context) === null || _a === void 0 ? void 0 : _a.product.stretch;
    const widthStretch = (_b = context.options.context) === null || _b === void 0 ? void 0 : _b.product.widthStretch;
    const lengthStretch = (_c = context.options.context) === null || _c === void 0 ? void 0 : _c.product.lengthStretch;
    if (value &&
        is4Way === __1.FabricAttributes.Stretch['4-way'] &&
        (!widthStretch ||
            widthStretch < 10 ||
            !lengthStretch ||
            lengthStretch < 10)) {
        return errorMsg;
    }
    else {
        return true;
    }
})
    .test('Test required stretch percentage for bundle quantity >= 10', (value, context) => {
    var _a, _b, _c, _d, _e;
    const errorMsg = context.createError({
        path: 'widthStretch',
        message: 'Bundles with Quantity 10 or more must have stretch percentage'
    });
    const isBundleOrRoll = (_a = context.options.context) === null || _a === void 0 ? void 0 : _a.product.bundleOrRoll;
    const bundleQuantity = (_b = context.options.context) === null || _b === void 0 ? void 0 : _b.product.quantity;
    const widthStretch = (_c = context.options.context) === null || _c === void 0 ? void 0 : _c.product.widthStretch;
    const lengthStretch = (_d = context.options.context) === null || _d === void 0 ? void 0 : _d.product.lengthStretch;
    const stretch = (_e = context.options.context) === null || _e === void 0 ? void 0 : _e.product.stretch;
    if (value &&
        isBundleOrRoll === __1.FabricAttributes.BundleOrRoll.Bundle &&
        (stretch === '4-way' || stretch === '2-way') &&
        bundleQuantity >= 10 &&
        (!widthStretch || widthStretch < 10) &&
        (!lengthStretch || lengthStretch < 10)) {
        return errorMsg;
    }
    else {
        return true;
    }
})
    .when('$product.bundleOrRoll', (bundleOrRoll, schema) => {
    // if (bundleOrRoll === BundleOrRoll.Roll) return schema.omit(['quantity']);
    return schema;
})
    .test('Context Check', "Fabric Validator needs fabric product in it's context", (_, context) => {
    var _a;
    if (!((_a = context.options.context) === null || _a === void 0 ? void 0 : _a.product))
        return false;
    return true;
})
    .test('uniqueDimensions', (_, context) => {
    var _a, _b;
    const lengthM = (_a = context.options.context) === null || _a === void 0 ? void 0 : _a.product.lengthM;
    const widthCM = (_b = context.options.context) === null || _b === void 0 ? void 0 : _b.product.widthCM;
    if (!lengthM || !widthCM)
        return true;
    if (lengthM.length === 0 || widthCM.length === 0)
        return true;
    // Generate unique number from lengthM and widthCM using pairing function
    const pairings = [];
    let widthI = 0;
    for (let i = 0; i < lengthM.length; i++) {
        widthI = widthCM.length > 1 ? widthCM[i] : widthCM[0];
        pairings.push(0.5 * (lengthM[i] + widthI) * (lengthM[i] + widthI + 1) + widthI); // https://math.stackexchange.com/a/23506
    }
    const pairingSet = new Set(pairings);
    if (pairingSet.size !== pairings.length)
        return context.createError({
            path: 'duplicateVariants',
            message: 'There cannot be duplicate variants.'
        });
    return true;
})
    .required();
//# sourceMappingURL=fabricSchema.js.map